module.exports = __webpack_public_path__ + "img/smp-logo.494d2c83.jpg";